export const sv = {
	"Select all": "Markera alla",
	"Deselect all": "Avmarkera alla",
	Select: "Markera",
	Deselect: "Avmarkera",
}
